import { useState } from 'react';
import { BrowserRouter, Link, NavLink, Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { CardsPage } from './pages/CardsPage';
import { TerritoriesPage } from './pages/TerritoriesPage';
import { RulesPage } from './pages/RulesPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ContactModal } from './components/ContactModal';

/**
 * Casca da aplicação: cabeçalho com navegação, rotas e rodapé.
 * Usamos BrowserRouter para URLs limpas (sem `#`). A hospedagem estática
 * precisa reescrever qualquer rota para index.html — ver public/_redirects
 * (Cloudflare Pages), senão um refresh em /como-jogar retorna 404.
 */
export function App(): React.JSX.Element {
  const [contactOpen, setContactOpen] = useState(false);
  return (
    <BrowserRouter>
      <div className="app-shell">
        <header className="site-header">
          <div className="container">
            <NavLink to="/" className="brand" aria-label="Game of Brasil — página inicial">
              <img src={`${import.meta.env.BASE_URL}title.png`} alt="Game of Brasil" />
            </NavLink>
            <nav className="nav" aria-label="Navegação principal">
              <NavLink to="/como-jogar">Como Jogar</NavLink>
              <NavLink to="/cartas">Cartas</NavLink>
              <NavLink to="/territorios">Territórios</NavLink>
            </nav>
          </div>
        </header>

        <main className="site-main">
          <div className="container">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/como-jogar" element={<RulesPage />} />
              <Route path="/cartas" element={<CardsPage />} />
              <Route path="/territorios" element={<TerritoriesPage />} />
              <Route path="/termos" element={<TermsPage />} />
              <Route path="/privacidade" element={<PrivacyPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </main>

        <footer className="site-footer">
          <div className="container">
            <span>Game of Brasil — guia oficial. Cartas e territórios vêm ao vivo do catálogo do jogo.</span>
            <nav className="footer-legal" aria-label="Documentos legais">
              <button
                type="button"
                className="footer-contact"
                onClick={() => setContactOpen(true)}
              >
                Falar com os desenvolvedores
              </button>
              <Link to="/termos">Termos de Uso</Link>
              <Link to="/privacidade">Política de Privacidade</Link>
            </nav>
          </div>
        </footer>

        {contactOpen && <ContactModal onClose={() => setContactOpen(false)} />}
      </div>
    </BrowserRouter>
  );
}
